import { render, staticRenderFns } from "./ServiceElderByPayType.vue?vue&type=template&id=3856550a&scoped=true&"
import script from "./ServiceElderByPayType.vue?vue&type=script&lang=js&"
export * from "./ServiceElderByPayType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856550a",
  null
  
)

export default component.exports